import { DateTime } from 'luxon';
import { SearchableScheduledEventSortableFields, SearchableSortDirection } from './type';
import type {
  GetEventsInput,
  GetEventsQueryVariables,
  Maybe
} from './type';
import type { GraphqlEventFilters } from './use-events';

export function transformFiltersToVariables(filters: GraphqlEventFilters): GetEventsQueryVariables {
  const sortOrderMap = {
    asc: SearchableSortDirection.Asc,
    desc: SearchableSortDirection.Desc,
    ASC: SearchableSortDirection.Asc,
    DESC: SearchableSortDirection.Desc
  };

  const sortFieldMap = {
    eid: SearchableScheduledEventSortableFields.Eid,
    startTime: SearchableScheduledEventSortableFields.StartTime,
    cid: SearchableScheduledEventSortableFields.Cid,
    organizationName: SearchableScheduledEventSortableFields.OrganizationName
  };

  const input: Maybe<GetEventsInput> = {
    sort_direction: sortOrderMap[filters.sortOrder],
    sort_field: sortFieldMap[filters.sortBy]
  };

  if (filters.dateRange?.min && filters.dateRange.max) {
    const { min, max } = filters.dateRange;

    const start = DateTime.fromJSDate(min).set({ hour: 0, minute: 0, second: 0 });
    const end = DateTime.fromJSDate(max).set({ hour: 23, minute: 60, second: 60 });

    input.start_time_gte = start.toISO();
    input.start_time_lte = end.toISO();
  }

  if (filters.search) {
    input.wildcard = filters.search;
  }

  if (filters.eventType) {
    input.event_type = filters.eventType;
  }

  if (filters.limit) {
    input.limit = filters.limit;
  }

  if (filters.eventIds) {
    input.ids = filters.eventIds.map(id => Number(id));
  }

  return {
  input
  };
}

/* Moved to the store so the app-wide events socket can use it; re-exported for existing callers. */
export { evictEventsFromCache } from '../../../store';
